export const RATING_ICON_WIDTH_LARGE = 24;
export const RATING_ICON_WIDTH = 16;
